import { inject, Pipe, PipeTransform } from '@angular/core';
import { User } from '@shared/api/api-loop/models/user';
import { UserAuthService } from '@shared/modules/auth/auth-data-access/user-auth.service';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'isMe$',
  standalone: false
})
export class IsMePipe implements PipeTransform {
  private readonly userAuthService: UserAuthService = inject(UserAuthService);

  transform(author?: User): Observable<boolean> {
    return this.userAuthService.currentSession$.pipe(map(currentSession => currentSession.user?.id === author?.id));
  }
}
